/* eslint-disable camelcase */
export const state = () => ({
  tinderBooks: [],
  userData: {
    goals: [],
    topics: [],
    consume_types: [],
    daily_reading_time: "",
    books_per_year: 0,
    app_usage_times: [],
    books: [],
    likedBooks: [],
    dislikedBooks: [],
    challengeBooks: [],
    selectedCategoryGroups: [],
    otherGoal: ""
  }
})
